import * as Yup from 'yup';

const initialValues = (keys) => {
  const initVal = { label: '' };
  keys.forEach((val) => {
    initVal[val] = '';
  });
  return initVal;
};

const validationSchema = (keys) => {
  const validSchema = {
    label: Yup.string().trim().required('Required'),
  };

  keys.forEach((val) => {
    validSchema[val] = Yup.string().trim().required('Required');
  });

  return Yup.object(validSchema);
};

/* eslint-disable import/prefer-default-export */
export { initialValues, validationSchema };
